import { render, staticRenderFns } from "./MenuClasificacion.vue?vue&type=template&id=18df2ee9&scoped=true&"
import script from "./MenuClasificacion.vue?vue&type=script&lang=js&"
export * from "./MenuClasificacion.vue?vue&type=script&lang=js&"
import style0 from "./MenuClasificacion.vue?vue&type=style&index=0&id=18df2ee9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18df2ee9",
  null
  
)

export default component.exports